export default __webpack_public_path__ + "static/data-vis-categorical-dont-4526187d00b35331bcfbbf56a4743da1.png";